import { createSvgIcon } from '@mui/material';

const WeightDimention = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 7C3 5.93913 3.42143 4.92172 4.17157 4.17157C4.92172 3.42143 5.93913 3 7 3H17C18.0609 3 19.0783 3.42143 19.8284 4.17157C20.5786 4.92172 21 5.93913 21 7V17C21 18.0609 20.5786 19.0783 19.8284 19.8284C19.0783 20.5786 18.0609 21 17 21H7C5.93913 21 4.92172 20.5786 4.17157 19.8284C3.42143 19.0783 3 18.0609 3 17V7Z"
      stroke="#9697AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7C13.956 7 15.724 7.802 17 9.095L14.044 11.999C13.4896 11.4855 12.7617 11.2001 12.006 11.2C11.2504 11.1999 10.5226 11.4848 9.968 11.998L7.012 9.095C7.66354 8.42994 8.44157 7.90197 9.30027 7.54218C10.159 7.18238 11.081 6.99804 12.012 7H12Z"
      stroke="#9697AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'WeightDimention',
);

export default WeightDimention;
